import React from 'react';

import Icons from '@/core/components/Icons';
import { useTranslationContext } from '@/core/lib/translation/translation.context';

const IsBlocked: React.FC = () => {
  const { t } = useTranslationContext(['common']);

  return (
    <div className="flex w-full flex-col">
      <div className="flex max-w-fit items-center gap-1 rounded-1 bg-bg-tag-status-pendingMod px-2 py-1">
        <p className="text-caption-primary text-content-tag-status-pendingMod">{t('components.is-blocked.title', { ns: 'common' })}</p>
      </div>

      <div className="mb-3 mt-2 flex">
        <div className="shrink-0">
          <Icons icon="info" color="danger" size="20" />
        </div>
        <p className="text-caption-primary ml-3 text-content-placeholder">{t('components.is-blocked.text', { ns: 'common' })}</p>
      </div>

      <div className="h-[1px] w-full bg-[#E83912]" />
    </div>
  );
};

export default IsBlocked;
